module.exports = __webpack_public_path__ + "files/7030c83df9ff4f0d09bb3ca079768a0e.svg";